import * as types from './mutation-types'

export default {
  [types.SET_OFFER_TO_SELLS] (state, offerToSells) {
    state.offerToSells = offerToSells
  },
  [types.SET_SELECTED_PREAPPROVED_INVOICE](state, data) {
    state.selectedPreapprovedInvoice = data
},
  [types.SET_TOTAL_OFFER_TO_SELLS] (state, totalOfferToSells) {
    state.totalOfferToSells = totalOfferToSells
  },

  [types.ADD_INVOICE] (state, data) {
    state.invoices.push(data)
  },

  [types.DELETE_INVOICE] (state, id) {
    let index = state.invoices.findIndex(invoice => invoice.id === id)
    state.invoices.splice(index, 1)
  },

  [types.SET_SELECTED_OFFERS] (state, data) {
    state.selectedOfferToSells = data
  },

  [types.UPDATE_INVOICE] (state, data) {
    let pos = state.invoices.findIndex(invoice => invoice.id === data.invoice.id)

    state.invoices[pos] = data.invoice
  },
  [types.ATTACHMENTS] (state, attachments) {
    state.attachments = attachments
  },
  [types.SET_TOTAL_ATTACHMENTS] (state, totalAttachments) {
    state.totalAttachments = totalAttachments
  },
  [types.SET_SELECT_ALL_STATE] (state, data) {
    state.selectAllField = data
  },
  [types.SET_SELECT_ALL_STATE_ATTACHMENT](state, data) {
    state.selectAllFieldAttachment = data
},
  [types.SET_SELECTED_ATTACHMENTS] (state, data) {
    state.selectedAttachments = data
  },
  [types.UPDATE_OFFER_TO_SELL_STATUS] (state, data) {
    let updateOfferToSell = state.offerToSells.findIndex(offerToSell => offerToSell.id === data.id)

    if (state.offerToSells[updateOfferToSell]) {
      state.offerToSells[updateOfferToSell].status = data.status
    }
  },

  [types.RESET_SELECTED_OFFERS] (state, data) {
    state.selectedOfferToSells = []
    state.selectAllField = false
  },

  [types.DELETE_MULTIPLE_INVOICES] (state, selectedInvoices) {
    selectedInvoices.forEach((invoice) => {
      let index = state.invoices.findIndex(_inv => _inv.id === invoice.id)
      state.invoices.splice(index, 1)
    })
    state.selectedInvoices = []
  },

  [types.SET_TEMPLATE_ID] (state, templateId) {
    state.invoiceTemplateId = templateId
  },

  [types.SELECT_CUSTOMER] (state, data) {
    state.selectedCustomer = data
  },

  [types.RESET_SELECTED_CUSTOMER] (state, data) {
    state.selectedCustomer = null
  },

  [types.SET_SELECT_ALL_STATE] (state, data) {
    state.selectAllField = data
  }
}
